import { Component, OnInit ,ViewChild, Inject} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { StaffService } from "../../staff/Shared/staff.service";
import { UsermanagementComponent } from "../../staff/usermanagement/usermanagement.component";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UsermanagementService } from "../Shared/usermanagement.service"

import { ConfirmationdialogService } from "../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";

@Component({
  selector: 'app-stafflist',
  templateUrl: './stafflist.component.html',
  styleUrls: ['./stafflist.component.css']
})

export class StafflistComponent implements OnInit {

  displayedColumns: string[] = ['RowNo', 'Id', 'code',  'Name', 'UserName', 'Email', 'Phoneno','Branch', 'Designation', 'Role', 'New'];
  toast : Toastpayload;

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private route: ActivatedRoute,
    private staffService: StaffService, public dialog: MatDialog,
    public usermanagementService : UsermanagementService,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,) { }

  ngOnInit() {
    this.Stafflist();
    this.dataSource.paginator = this.paginator;
  }

  public AddNew()
  {
    this.router.navigate(['/staff']);
  }

  Stafflist(){
    this.staffService.FetchStaffList().subscribe(data =>{
      this.dataSource.data = data;
      console.log(data)
    })
  }

  Edit(StaffRow : any){
    this.router.navigate(['/staff', { Id: StaffRow.Id }]);
  }

  // grid filter
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  // opening Usermanagement popup
  AddRole(Emp: any): void {
    const dialogRef = this.dialog.open(UsermanagementComponent, {
      width: '350px', height: '455px', panelClass: 'modal-dialog', autoFocus: false,
      data: { Id: Emp.Id, Name: Emp.Name, DesignationId: Emp.DesignationId,RoleId : Emp.RoleId }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
      // if (result != null) {
      //   console.log("reload");
      //  this.reload()
      // }
      console.log("reload");
      this.reload();
    });
  }

  // employee details deletion
  Delete(element: any) {

    // for deletion flag =3
    this.usermanagementService.selectedUser = {
      Id: element.Id,
      UserId: 0,
      DesignationId: 0,
      RoleId:0,
      Password: null,
      ModulesId: 0,
      FromDate : new Date(),
      ToDate : new Date(),
      IsTerminated: false,
      TerminatedDate: new Date(),
      Default  : false,
      EmployeeId: 0,
      EmployeeBranchId: 0,
      CompanyId: 0,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive  : false,
      Flag :3,
      IsRoleManagement: false,
      OldPassword: null,
  }

    this.toast = {
      message: "Staff details have been deleted",
      title: 'Staff deletion!', 
      ic:  {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'error',    
    };

    let title: string = "Confirmation";
    let message: string ="If you continue, Staff details will be removed. Are you sure? ";
    let btnOkText: string = "Yes";
    let  btnCancelText: string = 'No, Exit';
    
    
    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {
        
            this.usermanagementService.IUDUser(this.usermanagementService.selectedUser)
              .subscribe(data => {
                // console.log(data);
                this.toasterserviceService.showToast(this.toast);
                // this.router.navigate(['/stafflist']);

                this.reload();
              })  
          
        }
        else{
          this.toast.message = 'You are cancelled the staff details deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
    }

  // reloading the same page
  reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['./'], { relativeTo: this.route });
  }
}
